<template>
	<v-sheet elevation="0">
		<FunctionTitle :title="mainTitle" />
		<CommonFlame :title="pageTitle">
			<ValidationError :errors="errors" />
			<OrderConfirmationForm
				:order_confirmation="order_confirmation"
				:items="items"
				:btnText="btnText"
				:action="action"
				@submit="updateOrderConfirmation"
			/>
		</CommonFlame>
	</v-sheet>
</template>

<script>
import axios from "axios"

import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import ValidationError from "../shared/ValidationError.vue"
import OrderConfirmationForm from "../order_confirmation/components/OrderConfirmationForm.vue"

export default {
	components: {
		CommonFlame,
		FunctionTitle,
		ValidationError,
		OrderConfirmationForm,
	},
	data() {
		return {
			mainTitle: "受注内容確認書",
			pageTitle: "受注内容確認書編集",
			btnText: "更新する",
			action: "edit",
			order_confirmation: null,
			errors: [],
			items: {
				source_of_base_materials: [],
				attached_file_items: [],
				source_of_transports: [],
				transports: [],
			},
			order_confirmation: {
				reason: "",
				matter_id: "",
				source_of_base_material: "",
				scheduled_date_of_payment: "",
				scheduled_date_of_approval: "",
				exists_coating: null,
				coating_content: "",
				exists_process_photo: null,
				process_photo_content: "",
				exists_water_works: null,
				water_works_content: "",
				exists_witness: null,
				witness_content: "",
				exists_packaging: null,
				packaging_content: "",
				exists_attached_file: null,
				attached_file_content: "",
				transport: "",
				content: "",
				exists_quotation_cost: null,
				exists_order_amount: null,
				created_user: "",
				arrangement_availability: "",
				source_of_transport: "",
				source_of_base_material: "",
				file_url: [],
				removefiles: [],
			},
			id: this.$route.params["id"],
			matter_id: this.$route.params["matter_id"],
		}
	},
	mounted() {
		this.fetchOrderConfirmation()
	},
	methods: {
		fetchOrderConfirmation() {
			const headers = authenticate.setHeader()

			axios
				.get(`/erp/v1/order_confirmations/${this.id}/edit`, {
					params: { matter_id: this.matter_id },
					headers,
				})
				.then((res) => {
					this.items.source_of_base_materials = res.data.source_of_base_materials
					this.items.source_of_transports = res.data.source_of_transports
					this.items.attached_file_items = res.data.attached_file_items
					this.items.transports = res.data.transports

					this.order_confirmation.created_user = res.data.current_user
					this.order_confirmation.matter_id = res.data.order_confirmation.matter_id
					if (res.data.order_confirmation.source_of_transport) {
						this.order_confirmation.source_of_transport =	res.data.order_confirmation.source_of_transport
					}
					if (res.data.order_confirmation.source_of_base_material) {
						this.order_confirmation.source_of_base_material = res.data.order_confirmation.source_of_base_material
					}
					if (res.data.order_confirmation.scheduled_date_of_payment) {
						this.order_confirmation.scheduled_date_of_payment = res.data.order_confirmation.scheduled_date_of_payment
					}
					if (res.data.order_confirmation.scheduled_date_of_approval) {
						this.order_confirmation.scheduled_date_of_approval = res.data.order_confirmation.scheduled_date_of_approval
					}
	
					this.order_confirmation.exists_coating = res.data.order_confirmation.exists_coating

					if (res.data.order_confirmation.coating_content) {
						this.order_confirmation.coating_content = res.data.order_confirmation.coating_content
					}
					this.order_confirmation.exists_witness = res.data.order_confirmation.exists_witness
					if (res.data.order_confirmation.witness_content) {
						this.order_confirmation.witness_content = res.data.order_confirmation.witness_content
					}
					this.order_confirmation.exists_process_photo = res.data.order_confirmation.exists_process_photo
					if (res.data.order_confirmation.process_photo_content) {
						this.order_confirmation.process_photo_content = res.data.order_confirmation.process_photo_content
					}
					this.order_confirmation.exists_water_works = res.data.order_confirmation.exists_water_works
					if (res.data.order_confirmation.water_works_content) {
						this.order_confirmation.water_works_content = res.data.order_confirmation.water_works_content
					}
						this.order_confirmation.exists_packaging = res.data.order_confirmation.exists_packaging
					if (res.data.order_confirmation.packaging_content) {
						this.order_confirmation.packaging_content = res.data.order_confirmation.packaging_content
					}
					this.order_confirmation.exists_attached_file =res.data.order_confirmation.exists_attached_file
					if (res.data.order_confirmation.attached_file_content) {
						this.order_confirmation.attached_file_content = res.data.order_confirmation.attached_file_content
					}
					if (res.data.order_confirmation.transport) {
						this.order_confirmation.transport = res.data.order_confirmation.transport
					}
					if (res.data.order_confirmation.content) {
						this.order_confirmation.content = res.data.order_confirmation.content
					}
					this.order_confirmation.exists_quotation_cost =	res.data.order_confirmation.exists_quotation_cost
					this.order_confirmation.exists_order_amount =	res.data.order_confirmation.exists_order_amount
					this.order_confirmation.arrangement_availability = res.data.order_confirmation.arrangement_availability
					if (res.data.order_confirmation.file_url) {
						this.order_confirmation.file_url = res.data.order_confirmation.file_url
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		updateOrderConfirmation() {
			const headers = authenticate.setHeader()
			let formData = new FormData()

			Object.keys(this.order_confirmation).forEach((key) => {
				if (key === "file_url") return
				formData.set(`order_confirmations[${key}]`, this.order_confirmation[key])
			})
			if (this.order_confirmation.created_user) {
				formData.set('order_confirmations[created_user_id]', this.order_confirmation.created_user.id)
			}
			if (this.order_confirmation.file_url.length) {
				this.order_confirmation.file_url.forEach((file) => {
					formData.append(
						"order_confirmations[files]" + "[]",
						new Blob([file], {
							type: file.type,
						}),
						file.name
					)
				})
				if (this.order_confirmation.removefiles.length) {
					this.order_confirmation.removefiles.forEach((remove_file) => {
						formData.append(
							"order_confirmations[remove_files]" + "[]",
							new Blob([remove_file], {
								type: remove_file.type,
							}),
							remove_file.name
						)
					})
				}
			}

			axios
				.put(`/erp/v1/order_confirmations/${this.id}`, formData, { headers })
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "受注内容確認書を更新しました。",
					})
					this.$router.push({
						name: "order_confirmation_show",
						params: { matter_id: this.matter_id, id: this.id },
					})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
					const errors = errorHandling.errorResponse(err)
					if (Array.isArray(errors)) {
						this.errors = errors
					}
					window.scrollTo({
						top: 0,
						behavior: "smooth",
					})
				})
		},
	},
}
</script>
